import React, { useMemo } from 'react';

import { Polygon3D } from '@paragon/geometry-library';

import { LayoutPolygonVisualMode } from './common/mode';
import { getRoofFaceColor, LayoutPolygonStyle } from './common/style';
import { LayoutPolygonsEdgesCollection } from './edges/LayoutPolygonsEdgesCollection';
import { LayoutPolygonsEdgesRenderer } from './edges/LayoutPolygonsEdgesRenderer';
import { LayoutPolygonFaceMesh } from './faces/LayoutPolygonFaceMesh';

interface Props {
  polygons: readonly Polygon3D[];
  mode: LayoutPolygonVisualMode;
  style: LayoutPolygonStyle;
}

/**
   Renders a group of polygons with visual modes, styling, and render order. As roof and ceiling planes require more 
     complex processing this specific component is currently only used for faces coming from ceiling trays and feature 
     pattern objects.
 */
export function LayoutPolygonCollection({ polygons, mode, style }: Props) {
  const segments = useMemo(() => {
    const result = new LayoutPolygonsEdgesCollection();
    for (const polygon of polygons) {
      result.addPolygonEdges(polygon, getRoofFaceColor(style));
    }
    return result;
  }, [polygons, style]);

  return (
    <group>
      <LayoutPolygonsEdgesRenderer segments={segments} />

      {mode !== 'wireframe' &&
        polygons.map((polygon, i) => (
          <LayoutPolygonFaceMesh key={i} geometry={polygon} mode={mode} color={getRoofFaceColor(style)} />
        ))}
    </group>
  );
}
